
import Vue from 'vue';
import Component from 'vue-class-component';

import { Line, mixins } from 'vue-chartjs';
import { Chart, ChartOptions, ChartData } from 'chart.js';
import { Prop, Mixins } from 'vue-property-decorator';
import chartjsPluginAnnotation from "chartjs-plugin-annotation"

@Component
export default class VueLineChart extends Mixins(Line, mixins.reactiveProp) {
    @Prop({ default: () => { return null; }}) options!: ChartOptions;
    @Prop() chartData!: ChartData; 

    mounted() {
        this.addPlugin(chartjsPluginAnnotation),
        this.renderChart(this.chartData, this.options);
    }
};
